import IMainState from "system/types/store/IMainState";

const mainState: IMainState = {
  pageTitle: "",
  subTitle: "",
  filters: null,
  filteredEndpointCount: null,
  endpointCounts: null,
  lastFilterSet: new Date().getTime(),
  breadcrumbs: [],
  isMobileSidebarVisible: false,
  icons: [],
};

export default mainState;
